import ApiCore from './utilities/core'
import apiProvider from './utilities/provider'

const url = 'reference-form-config'

const apiReferenceFormConfig = new ApiCore({
  getAll: true,
  getSingle: true,
  post: false,
  put: false,
  patch: false,
  delete: false,
  url,
})

apiReferenceFormConfig.getByCompany = (companyId) =>
  apiProvider.getAll(`${url}/companies/${companyId}`)

export default apiReferenceFormConfig
